/**
 * Document category ID for Service Records.
 */
export const SERVICE_RECORDS_CATEGORY_ID = '69a9480103f8e4109a50ef13'

/**
 * Maximum number of documents allowed per service record.
 */
export const MAX_DOCUMENTS = 3
